export const GAME_CATALOG_UPDATED = 'starsplay/game-catalog/GAME_CATALOG_UPDATED'
export const GAME_CATALOG_CATEGORIES_UPDATED =
  'starsplay/game-catalog/GAME_CATALOG_CATEGORIES_UPDATED'
export const GAME_CATALOG_SECTIONS_UPDATED =
  'starsplay/game-catalog/GAME_CATALOG_SECTIONS_UPDATED'
export const GAME_CATALOG_GAMES_UPDATED =
  'starsplay/game-catalog/GAME_CATALOG_GAMES_UPDATED'
